"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = __importDefault(require("../../Core/Entity"));
var Routes = {
    GET: '/delivery_blocks',
    CREATE: '/delivery_blocks',
    UPDATE: '/delivery_blocks/{:id}',
    DELETE: '/delivery_blocks/{:id}',
    GET_BY_DRIVER_ID: '/delivery_blocks/users/{:id}',
    GET_TEMPLATES: '/delivery_blocks/templates',
    GET_TEMPLATE_BY_ID: '/delivery_blocks/templates/{:id}',
    CREATE_TEMPLATE: '/delivery_blocks/templates',
    UPDATE_TEMPLATE: '/delivery_blocks/templates/{:id}',
    DELETE_TEMPLATE: '/delivery_blocks/templates/{:id}'
};
var DeliveryBlocksEntity = /** @class */ (function (_super) {
    __extends(DeliveryBlocksEntity, _super);
    function DeliveryBlocksEntity(session) {
        return _super.call(this, { session: session, entityName: 'delivery_blocks', routes: [] }) || this;
    }
    DeliveryBlocksEntity.prototype.get = function (teamId, startTime, endTime, dateRangeType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(Routes.GET)
                            .withQueryString({
                            team_id: teamId,
                            start_time: startTime,
                            end_time: endTime,
                            date_range_type: dateRangeType
                        })
                            .setException("Could not fetch delivery block for team #".concat(teamId))
                            .withExtractor(function (result) { return result.delivery_blocks; })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryBlocksEntity.prototype.create = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(Routes.CREATE)
                            .withPayload(options)
                            .withExtractor(function (result) { return result.delivery_block; })
                            .setException("Could not create delivery block for team #".concat(options.team_id))
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryBlocksEntity.prototype.update = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var id, payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = options.id, payload = __rest(options, ["id"]);
                        return [4 /*yield*/, this.service.routeGenerator
                                .put(Routes.UPDATE)
                                .withExtractor(function (result) { return result.delivery_block; })
                                .setException("Could not update delivery block for team #".concat(options.team_id))
                                .withRouteParams({ id: id })
                                .withPayload(payload)
                                .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryBlocksEntity.prototype.delete = function (id, recurring) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .delete(Routes.DELETE)
                            .withExtractor(function (result) { return result.success; })
                            .setException("Could not delete delivery block with id #".concat(id))
                            .withRouteParams({ id: id })
                            .withQueryString({ recurring: recurring })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryBlocksEntity.prototype.getByDriverId = function (driverId, startTime, endTime, teamId, dateRangeType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get('/delivery_blocks/users/{:id}')
                        .withExtractor(function (result) { return result.delivery_blocks; })
                        .withRouteParams({ id: driverId })
                        .setException("Could not fetch delivery block for user with id #".concat(driverId))
                        .withQueryString({
                        start_time: startTime,
                        end_time: endTime,
                        team_id: teamId,
                        date_range_type: dateRangeType
                    })
                        .invoke()];
            });
        });
    };
    DeliveryBlocksEntity.prototype.getTemplates = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(Routes.GET_TEMPLATES)
                        .withExtractor(function (result) { return result.delivery_blocks_templates; })
                        .setException('Could not fetch delivery blocks templates')
                        .invoke()];
            });
        });
    };
    DeliveryBlocksEntity.prototype.getTemplateById = function (templateId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(Routes.GET_TEMPLATE_BY_ID)
                        .withExtractor(function (result) { return result.delivery_blocks_template; })
                        .withRouteParams({ id: templateId })
                        .setException("Could not fetch delivery block template with id: #".concat(templateId))
                        .invoke()];
            });
        });
    };
    DeliveryBlocksEntity.prototype.createTemplate = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post(Routes.CREATE_TEMPLATE)
                        .withPayload(payload)
                        .setException('Could not create delivery blocks template')
                        .invoke()];
            });
        });
    };
    DeliveryBlocksEntity.prototype.updateTemplate = function (templateId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .put(Routes.UPDATE_TEMPLATE)
                        .withRouteParams({ id: templateId })
                        .withPayload(payload)
                        .setException("Could not update delivery blocks template with id: #".concat(templateId))
                        .invoke()];
            });
        });
    };
    DeliveryBlocksEntity.prototype.deleteTemplate = function (templateId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .delete(Routes.DELETE_TEMPLATE)
                        .withRouteParams({ id: templateId })
                        .setException("could not delete delivery block template with id: #".concat(templateId))
                        .invoke()];
            });
        });
    };
    return DeliveryBlocksEntity;
}(Entity_1.default));
exports.default = DeliveryBlocksEntity;
//# sourceMappingURL=DeliveryBlocksEntity.js.map